import { Observable } from 'rxjs';
import {
  idNameItem,
  close2List,
  close2AllList,
  YNList,
  jkLib,
  JkBaseFormType,
  JkBaseOption,
  jkRestReturn,
  dateFormatter,
} from 'jk-service';
import { MtrwdServicePkg } from './mtrwdPkg.service';
import { Mtrwd } from '../entity/Mtrwd-angular';
import { ColDef } from 'ag-grid-community';
import {
  AgHtmlCellRenderer,
  AgComboBoxEditor,
  AgMarkdownCellRenderer,
  AgCheckBoxEditor,
  AgTextAreaEditor,
} from 'jk-service';

export class MtrwdPageOption extends JkBaseOption {
  displayMode: string = 'simple'; // simple | standard | advanced
  wd004v1: boolean = false; //主旨
  wd004v2: boolean = true;
  wd021v1: boolean = false; //客戶
  wd021v2: boolean = true;
  simpleVisible: boolean = true;
  displayModeChange($event: any) {
    console.log($event);
    if ($event.detail.value == 'simple') {
      this.wd004v1 = false;
      this.wd004v2 = true;
      this.simpleVisible = true;
    } else if ($event.detail.value == 'standard') {
      this.wd004v1 = true;
      this.wd004v2 = false;
      this.simpleVisible = false;
    } else {
      //advanced
      this.wd004v1 = true;
      this.wd004v2 = true;
      this.simpleVisible = false;
    }
  }

  copma_w01: object[] = [];
  cmsmv_w01: object[] = [];
  currentTab: string[] = [];
  //public orm: OrmService = inject(OrmService);
  constructor(name: string) {
    super(name);
  }
  override init(): void {
    super.init();
    this.orm.getopenwin('CMSMV', 'W01', 'W').subscribe((data) => {
      this.cmsmv_w01 = data;
    });
    this.orm.getopenwin('COPMA', 'W01', 'W').subscribe((data) => {
      this.copma_w01 = data;
    });
  }
}

export class MtrwdService extends MtrwdServicePkg {
  private _mtrwd015List: idNameItem[] = [];
  get MtrWd015List(): idNameItem[]{ // 大分類
    return this._mtrwd015List;
  }

  private _mtrwd016List: idNameItem[] = [];
  get MtrWd016List(): idNameItem[]{ // 大分類
    return this._mtrwd016List;
  }
  public getMtrwd016List(wd015: string): idNameItem[] {
    let r = this._mtrwd016List.filter((x) => {
      return x.ps1 === wd015;
    });
    return r;
  }
  private _mtrwd024List: idNameItem[] = [];//小分類
  get MtrWd024List(): idNameItem[]{ // 大分類
    return this._mtrwd024List;
  }
  public getMtrwd024List(wd015: string, wd016: string): idNameItem[] {
    let r = this._mtrwd024List.filter((x) => {
      return x.ps1 === wd015 && x.ps2 === wd016;
    });
    return r;
  }
  MtrWd017List: idNameItem[] = close2List; //  [{ id: "Y", name: "Y:已結案" }, { id: "N", name: "N:未結案" }];
  MtrWd017ListAll: idNameItem[] = close2AllList; // = jkLib.makeOptionAll(this.dsWD017); // this.dsWD017.push({ id: "", name: "全部" });
  MtrWd027List = YNList;
  YNList: idNameItem[] = YNList;
  override cboOrder = [
    {
      id: '0',
      name: '工作日期+優先順序',
      order: ' ORDER BY WD002 DESC,WD012 ',
    },
    {
      id: '1',
      name: '工作日期+客戶代號',
      order: ' ORDER BY WD002 DESC,WD021 ',
    }, // 工作日期+客戶代號
    {
      id: '2',
      name: '預計日期+優先順序',
      order: ' ORDER BY WD005 DESC,WD012 ',
    },
    { id: '3', name: '客戶代號+工作日期', order: ' ORDER BY WD021,WD002 DESC' },
    { id: '4', name: '優先順序', order: ' ORDER BY WD012 ' },
  ]; //
  constructor() {
    super();
    this.orm.doOpenWin_get('S', 'JCKMG', 'S01', ['MTRWD']).subscribe((data: any) => {
      if (data.result) this._mtrwd015List = data.obj;
    });
    this.orm
      .doOpenWin_get('S', 'JCKMH', 'S01', ['MTRWD'])
      .subscribe((data: any) => {
        if (data.result) this._mtrwd016List = data.obj;
      });
    this.orm
      .doOpenWin_get('S', 'JCKMI', 'S01', ['MTRWD'])
      .subscribe((data: any) => {
        if (data.result) this._mtrwd024List = data.obj;
      });


    this.columnDefs = [
      {
        field: 'WD027',
        headerName: '星號',
        headerTooltip: '',
        width: 80,
        cellDataType: 'text',
        cellRenderer: AgCheckBoxEditor,
      },
      {
        field: 'WD002',
        headerName: '工作日期',
        headerTooltip: '',
        width: 120,
        cellDataType: 'text',
        valueFormatter: dateFormatter,
      },
      {
        field: 'WD018',
        headerName: '星期',
        headerTooltip: '',
        width: 80,
        cellDataType: 'text',
      },
      {
        field: 'WD004',
        headerName: '主旨',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
        cellEditor: 'agLargeTextCellEditor',
        cellRenderer: AgTextAreaEditor,
      },
      {
        field: 'WD003',
        headerName: '內文',
        headerTooltip: '',
        width: 350,
        cellDataType: 'text',
        cellEditor: 'agLargeTextCellEditor',
        cellRenderer: AgMarkdownCellRenderer,
      },
      {
        field: 'WD025',
        headerName: '計費',
        headerTooltip: '',
        width: 80,
        cellDataType: 'number',
        cellStyle: { 'text-align': 'right' },
      }, // ^_^
      {
        field: 'WD015',
        headerName: '大分類',
        headerTooltip: '',
        width: 150,
        cellDataType: 'text',
        cellRenderer: AgComboBoxEditor,
        cellRendererParams: { list: this.MtrWd015List },
      },
      {
        field: 'WD016',
        headerName: '中分類',
        headerTooltip: '',
        width: 150,
        cellDataType: 'text',
        cellRenderer: AgComboBoxEditor,
        cellRendererParams: { list: this.MtrWd016List },
      },
      {
        field: 'WD024',
        headerName: '小分類',
        headerTooltip: '',
        width: 230,
        cellDataType: 'text',
        cellRenderer: AgComboBoxEditor,
        cellRendererParams: { list: this.MtrWd024List },
      },
      {
        field: 'WD014',
        headerName: '工作者',
        headerTooltip: '',
        width: 150,
        cellDataType: 'text',
      },
      {
        field: 'WD021',
        headerName: '客戶代號',
        headerTooltip: '',
        width: 150,
        cellDataType: 'text',
      },
      {
        field: 'WD011',
        headerName: '狀態',
        headerTooltip: '',
        width: 80,
        cellDataType: 'text',
        cellRenderer: AgComboBoxEditor,
        cellRendererParams: { list: this.MtrWd011List },
      },
      {
        field: 'WD017',
        headerName: '結案碼',
        headerTooltip: '',
        width: 80,
        cellDataType: 'text',
        cellRenderer: AgCheckBoxEditor,
      },
      {
        field: 'WD010',
        headerName: '提醒碼',
        headerTooltip: '',
        width: 80,
        cellDataType: 'text',
      },
      {
        field: 'WD005',
        headerName: '提醒日期',
        headerTooltip: '',
        width: 120,
        cellDataType: 'text',
        valueFormatter: dateFormatter,
      },
      {
        field: 'WD006',
        headerName: '提醒時間',
        headerTooltip: '',
        width: 118,
        cellDataType: 'text',
      },
      {
        field: 'WD012',
        headerName: '優先順序',
        headerTooltip: '',
        width: 80,
        cellDataType: 'text',
      },
      {
        field: 'WD013',
        headerName: '進度',
        headerTooltip: '',
        width: 94,
        cellDataType: 'number',
        cellStyle: { 'text-align': 'right' },
      },
      {
        field: 'WD020',
        headerName: '預估時數',
        headerTooltip: '',
        width: 136,
        cellDataType: 'number',
        cellStyle: { 'text-align': 'right' },
      },
      {
        field: 'WD022',
        headerName: '私人的',
        headerTooltip: '',
        width: 80,
        cellDataType: 'text',
        cellRenderer: AgCheckBoxEditor,
      },
      {
        field: 'WD023',
        headerName: '週期',
        headerTooltip: '',
        width: 80,
        cellDataType: 'text',
        cellRenderer: AgComboBoxEditor,
        cellRendererParams: { list: this.MtrWd023List },
      },
      {
        field: 'WD019',
        headerName: '金額',
        headerTooltip: '',
        width: 134,
        cellDataType: 'number',
        cellStyle: { 'text-align': 'right' },
      },
      {
        field: 'WD026',
        headerName: 'html內文',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
        cellEditor: 'agLargeTextCellEditor',
        cellRenderer: AgHtmlCellRenderer,
      },
      {
        field: 'WD028',
        headerName: '來源單號',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
      },
      {
        field: 'WD001',
        headerName: '建檔時間',
        headerTooltip: '',
        width: 230,
        cellDataType: 'text',
      },
    ];

    //this.wd015Init();
    const cols: ColDef[] = [
      {
        field: 'CNT',
        headerName: '明細',
        headerTooltip: '',
        width: 60,
        cellDataType: 'number',
        cellStyle: { 'text-align': 'right' },
      },
    ];
    this.columnDefsVir.push(...cols);
  }
  override afterContructor() {
    super.afterContructor();
    this.topN = 1000;
    if (this.programId === 'mtrki04') {
      this.topN = 1000;
    }
    this.sqlSelect = `SELECT TOP ${this.topN} isNull(WL.CNT,0) AS CNT,A.MG003 AS WD015C,B.MG003 AS WD016C,C.MG003 AS WD024C,
MV002 AS WD014C,COPMA.MA002 AS WD021C,MTRWD.*
FROM MTRWD
LEFT JOIN COPMA ON MA001=WD021
LEFT JOIN CMSMV ON MV001=WD014
LEFT JOIN JCKMG AS A ON A.MG001='MTRWD' AND A.MG002=WD015
LEFT JOIN JCKMG AS B ON B.MG001='MTRWD2' AND B.MG002=WD016
LEFT JOIN JCKMG AS C ON C.MG001='MTRWD3' AND C.MG002=WD024
LEFT JOIN (SELECT count(*) as CNT,WL001 FROM MTRWL GROUP BY WL001) AS WL  ON WL.WL001=WD001 `;
  }
  override init() {
    super.init();
  }
  wd015Count(): number {
    return this.itemList().length;
  }
  private _wd015: string = '';
  set wd015(value: string) {
    this._wd015 = value;
  }
  get wd015(): string {
    return this._wd015;
  }
  public get isWork(): boolean {
    //if (!this.masterSrv) return false;
    if (!this.item) return false;

    return this.item.wd015 === 'W';
  }
  override async newRecord(newItem: Mtrwd): Promise<Mtrwd> {
    await super.newRecord(newItem);
    //let newItem: Mtrwd = await super.newRecord();
    newItem.WD001 = jkLib.nowDate() + '-' + jkLib.nowTime9();
    newItem.WD002 = jkLib.nowDate();
    newItem.WD011 = '1';
    newItem.WD012 = '5';
    newItem.WD013 = 0;
    newItem.WD014 = this.userId;
    newItem.WD015 = this.wd015; // 'W';
    if (this.wd015 === 'W') {
      newItem.WD021 = 'AJM';
    } else {
      newItem.WD021 = '';
    }
    newItem.WD018 = jkLib.day2Week(newItem.WD002, 4);
    newItem.WD022 = 'N';
    return newItem;
  }
  override async validateItem(item: Mtrwd): Promise<boolean> {
    let bool = await super.validateItem(item);
    if (bool) {
      // TODO: need test
      if (item.WD015 === 'W') {
        if (item.WD021 === '') {
          alert('客戶代號不可空白');
          bool = false;
        }
      }
    }
    return bool;
  }

  wd014_displayExpr(item: any): string {
    let text: string = item && `${item.MV001} <${item.MV002}>`;
    return text;
  }

  wd017Validation(e: any) {
    //結案碼
    if (e.value) {
      e.data.WD006 = jkLib.nowTime4();
      if (e.data.WD002 === '') {
        e.data.WD002 = jkLib.nowDate();
        e.data.WD018 = jkLib.day2Week(e.data.WD002, 4);
      }
    }
  }
  async wd017Update(item: Mtrwd) {
    //結案碼
    let key = this.getKeyValues(item);

    await this.updateData(key, item);
    alert('已更新');
  }
  async toggleStar(item: Mtrwd, isUpdate: boolean = true): Promise<void> {
    if (!confirm('確定切換?')) return;
    if (item.WD027 === 'Y') {
      item.WD027 = 'N';
    } else {
      item.WD027 = 'Y';
    }
    if (isUpdate) {
      let key = this.getKeyValues(item);
      await this.updateData(key, item);
      alert('已更新*');
    }
  }
  // 切換待辦事項
  getTodo(value: string): Observable<any> {
    this.wd015 = value;
    //if (!value) return null;
    if (!value) {
      this.sqlWhere = ` AND WD017='N'`;
    } else {
      this.sqlWhere = ` AND WD017='N' AND WD015='${value}'`;
    }
    this.sqlOrder = ` ORDER BY WD002 DESC,WD012 `;
    return this.loadByHttpClient(this.sqlWhere, this.sqlOrder);
  }
  getTodoCounts(idItems: idNameItem[]): void {
    //return; // mtrki01
    //if (this.programId === 'mtrki04') return;
    let items = idItems.map((x) => x.id);
    let sql = `SELECT WD015,COUNT(*) AS CNT FROM MTRWD WHERE WD017='N' `;

    sql = jkLib.array2Where(items, sql, 'WD015');
    sql = sql + ` GROUP BY WD015 ORDER BY WD015 `;
    this.orm.simpleSql(this.login.hostName, sql).subscribe((data: any) => {
      let r: any[] = data;
      for (let i = 0; i < idItems.length; i++) {
        let id = r.find((x) => x.WD015 === idItems[i].id);
        if (id) {
          idItems[i].ps1 = id.CNT;
        } else {
          idItems[i].ps1 = '0';
        }
      }
    });
  }
  WD002Change(value: string) {
    this.item.WD018 = jkLib.day2Week(value, 4);
  }
  async WD012Change(value: any) {
    // 優先順序
    console.log('WD012Change', value);
  }
  private _checkLock = Promise.resolve();
  async WD014Change(value: string) {
    // 使用者
    this._checkLock = this._checkLock.then(async () => {
      let bool = await this.advCheck(
        'WD014',
        this.item,
        'CMSMV',
        'V01',
        'WD014C',
        [value],
        'E',
        '員工代號錯誤',
      );
      if (!bool) {
        //alert('員工代號' + value);
        //ownForm.doShowJson(this.item);
      }
    });
    await this._checkLock;
  }
  async WD021Change(value: string, ownForm: JkBaseFormType) {
    // 客戶代號
    this._checkLock = this._checkLock.then(async () => {
      let bool = await this.advCheck(
        'WD021',
        this.item,
        'COPMA',
        'V01',
        'WD021C',
        [value],
        'E',
        '客戶代號錯誤',
      );
      if (!bool) {
        //alert('客戶代號' + value);
        //ownForm.doShowJson(this.item);
      }
    });
    await this._checkLock;
  }
  override async beforeInsert(item: any): Promise<void> {
    await super.beforeInsert(item);
  }
  override async afterInsert(item: any): Promise<void> {
    await super.afterInsert(item);
    // console.log('afterInsert', item);
  }
  //quillEditorOptions = quillEditorOptions;
  /*quillEditorReady(event: any) {
    if (event.text.trim() !== '') {
      //this.item.WD026 = event.html;
      this.item.WD003 = event.text;
    }
  }
  textChange($event: string) {
    this.item.WD003 = $event;
  }*/
  /*htmlChange($event: string) {
    this.item.WD026 = $event;
  }*/
  doWD015Change(value: string) {
    this.getTodo(value).subscribe((data: any) => {
      // 使用 setTimeout 將更新延遲到下一個變更檢測週期
      setTimeout(() => {
        this.setItemList(data.obj);
        this.doRefresh();
        if (this.onAfterScroll) this.onAfterScroll(this.item, this.jkRet);
      });
    });
  }
  _wd015Index: number = 0;
  get wd015Index(): number {
    return this._wd015Index;
  }
  set wd015Index(value: number) {
    this._wd015Index = value;
    if (this.MtrWd015List.length > value) {
      this.wd015 = this.MtrWd015List[value].id;
      this.doWD015Change(this.wd015);
    }
  }
  get wd015Str(): string {
    return this.wd015;
  }
  set wd015Str(value: string) {
    this.wd015 = value;
    this.doWD015Change(this.wd015);
  }
  content(): string {
    return this.item.WD003 || '';
  }
  editContent(value: string): void {
    this.item.WD003 = value;
    //this.markEdited();
  }

}
